export default function BrandLogo({ compact = false, caption = 'Workspace de ventas', admin = false }) {
  return (
    <div className={`app-brand ${compact ? 'is-compact' : ''} ${admin ? 'is-admin' : ''}`}>
      <img className="brand-mark-image" src="/logo-mark.svg" alt="" aria-hidden="true" />
      <div>
        <div className="brand-name"><b>Stream</b>Control</div>
        {!compact && <div className="brand-caption">{caption}</div>}
      </div>
    </div>
  );
}
